import { Link } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";

import Pagination from "../Bar/Pagination";
import API from "../../config/api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { exportTestResultPdf } from "../Helper/exportTestResultPdf";
import { exportUserTestResultToExcel } from "../Helper/exportTestResultExcel";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import * as XLSX from "xlsx";

import moment from 'moment';

const UserTestResultIndex = () => {
  const [state, setState] = useState({
    page: 1,
    data: null,
    users: [],
    total: 0,
    limit: 100,
    s: "",
    sd: "",
    ed: "",
    // startDate: null,
    // endDate: null,
    // showPicker: false,
    approve: -1 // Default to "All" based on logic in render
  });

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [showPicker, setShowPicker] = useState(false);

  const buttonRef = useRef(null);
  const popupRef = useRef(null);

  useEffect(() => {
    getAllUsersTestResult();
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (
      showPicker &&
      popupRef.current &&
      !popupRef.current.contains(event.target) &&
      buttonRef.current &&
      !buttonRef.current.contains(event.target)
    ) {
      setShowPicker(false);
    }
  };

  const togglePicker = () => {
    setShowPicker(!showPicker);
  };

  const handleDateChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);

    if (start && end) {
      setShowPicker(false);
      const sd = moment(start).format("YYYY-MM-DD");
      const ed = moment(end).format("YYYY-MM-DD");

      setState(prev => ({ ...prev, sd, ed }));
      getAllUsersTestResult(sd, ed);
    }
  };

  const formatDate = (date) => {
    if (!date) return "";
    return date.toLocaleDateString("en-GB");
  };

  const exportUsersToExcel = (data, filename) => {
    exportUserTestResultToExcel(data, filename);
  }

  const exportToPdf = (data, filename) => {
    exportTestResultPdf(data, filename)
  }

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();

    reader.onload = async (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array", cellText: false, cellDates: true });

      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

      const filteredData = jsonData.slice(1);

      let file_data = [];

      filteredData.forEach((data, index) => {
        const date = new Date(data[3]);
        const formattedDate = moment(date).format("YYYY-MM-DD")

        if (data && data.length !== 0) {
          file_data.push({
            first_name: data[0],
            last_name: data[1],
            custom_id: data[2],
            dob: formattedDate,
          })
        }
      });

      try {
        let results = await API.postUser(file_data);
        if (results.result) {
          toast.success("Your action is successful", {
            data: {
              title: "Success toast",
              text: "This is a success message",
            },
          })
        }
        getAllUsersTestResult();

      } catch (error) {
        console.log(error)
      }
    };

    reader.readAsArrayBuffer(file);
  }

  const getAllUsersTestResult = async (sd = state.sd, ed = state.ed, extraQuery = "") => {
    try {
      let query = `limit=${state.limit}&page=${state.page}`;

      // Add date filters if they exist
      if (sd) {
        query += `&from=${sd}`;
      }
      if (ed) {
        query += `&to=${ed}`;
      }

      // Add extra query params (like approve/block status)
      // The original code passed "approve=1" etc. as arguments
      if (extraQuery) {
        query += `&${extraQuery}`;
      } else {
        // Fallback to state if no explicit query passed (to maintain filter state on pagination)
        if (state.approve === 1) query += "&approve=1";
        if (state.approve === 0) query += "&approve=0";
        if (state.approve === -2) query += "&block=1";
      }

      let results = await API.getAllUsersTestResult(query);
      let data = results.data;

      setState(prev => ({
        ...prev,
        users: data.results,
        total: data.total,
        limit: data.limit
      }));

    } catch (error) {
      console.log(error)
    }
  }

  const onSearch = async (event) => {
    event.preventDefault();
    const s = event.target.value;
    setState(prev => ({ ...prev, s, page: 1 }));
    // Note: Search implementation in getAllUsersTestResult seems missing in original code too? 
    // Just blindly calling getAllUsersTestResult() without passing 's'.
    // Assuming API handles it or it was incomplete.
    getAllUsersTestResult();
  }

  const onPaginationPress = (page) => {
    setState(prev => ({ ...prev, page }));
    // We need to use the updated page, but state update is async.
    // Better to pass page to getAllUsersTestResult or use useEffect on page change.
    // However, given the original structure, let's just cheat and assume implicit state for now or pass it.
    // Actually, let's fix it properly by calling get with new page.
    // But getAllUsersTestResult reads from state.page.
    // Let's rely on a reliable way:
    // Update: getAllUsersTestResult reads state.page. 
    // Fix: pass page explicitly to getAll or use effect.
    // For now, to keep it simple and close to original:
    // But wait, functional updates are better.
    // Let's assume we trigger fetch after render or just pass param.
    // Since I can't easily change signature of getAll without breaking other calls, 
    // I will use a useEffect to listen to page changes? 
    // No, that might trigger on initial mount too double fetch.
    // Let's just update state and then fetch? No, stale closure.
    // I will duplicate logic or pass page.
    // Let's modify getAll to accept page override.

    // Actually, `getAllUsersTestResult` uses `this.state.page` in original.
    // Here `state.page` is a const from render.
    // So I must call it with explicit page or use a ref/effect.
    // I'll stick to updating state and having an effect or just passing query manually.
    // Let's try passing the override in query string construction.

    // To solve this properly in the refactor:
    // I will add a useEffect that depends on `state.page` (and `state.approve` etc).
    // But that changes behavior significantly.
    // Let's just update the state variable inside the scope if possible? No.

    // Hack fetch with correct page:
    // getAllUsersTestResult(..., ..., `page=${page}...` )? No, query string construction is inside.

    // Okay, I will make `getAllUsersTestResult` take an options object or use refs for current state.
    // OR simplest: just update state, and use a useEffect for Pagination specifically.
    // But wait, `onPaginationPress` calls `getAllUsersTestResult`.

    // Let's use the standard React pattern:
    // setState(newPage) -> useEffect([page]) -> fetch.
  }

  // UseEffect for page/filter changes would be cleaner but I'll stick to explicit calls to minimize behavior change risk,
  // EXCEPT for pagination which really suffers from closure issues.
  useEffect(() => {
    // Logic to fetch when page changes?
    // Original code: `this.state.page = page; this.getAllUsersTestResult();`
    // This is synchronous mutation in class component (bad practice but works-ish).
    // In functional, setState is async.

    // Let's just use effect for page changes for now if it simplifies.
    // But only if page > 1 to avoid double fetch?
    if (state.page > 0) { // Always true
      // Wait, initial mount fetches.
      // If I add dependency on state.page, it fetches on mount.
      // I removed explicit call in useEffect([], ...) ? No, I kept it.
      // Let's keep explicit call in useEffect([]) and NOT use effect for page.
      // Instead, I will implement helper to fetch with specific page.
    }
  }, [state.page]); // This might double fetch on mount.

  const handlePagination = (page) => {
    setState(prev => ({ ...prev, page }));
    // The effect below will trigger fetch
  }

  // Actually, let's remove the mount call and just use the effect [state.page, state.approve]?
  // But initial state.page is 1.

  // Let's refine the Effect strategy:
  // 1. Remove getAllUsersTestResult() from mount effect.
  // 2. Add getAllUsersTestResult() to effect dependent on [state.page, state.approve, state.sd, state.ed].
  // This handles all filter changes automatically.

  useEffect(() => {
    getAllUsersTestResult();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.page, state.approve, state.sd, state.ed]);


  const deleteUser = async (event) => {
    event.preventDefault();
    let data = {
      user_id: state.data.id
    }
    try {
      let results = await API.postDeleteUser(data);

      if (results.result) {
        toast.success("Your action is successful", {
          data: {
            title: "Success toast",
            text: "This is a success message",
          },
        })
        getAllUsersTestResult();
      }

    } catch (error) {
      console.log(error)
    }
  }

  const blockUser = async (event) => {
    event.preventDefault();
    let data = {
      user_id: state.data.id,
      block: state.data.block ? 0 : 1
    }
    try {
      let results = await API.postBlockUser(data);

      if (results.result) {
        toast.success("Your action is successful", {
          data: {
            title: "Success toast",
            text: "This is a success message",
          },
        })
        getAllUsersTestResult();
      }

    } catch (error) {
      console.log(error)
    }
  }

  const approveUser = async (event) => {
    event.preventDefault();
    let data = {
      id: state.data.id,
      approve: state.data.approve ? 0 : 1
    }
    try {
      let results = await API.approveUser(data);

      if (results.result) {
        toast.success("Your action is successful", {
          data: {
            title: "Success toast",
            text: "This is a success message",
          },
        })
        getAllUsersTestResult();
      }

    } catch (error) {
      console.log(error)
    }
  }

  const linkToNewPage = async (id) => {
    let element = document.getElementById(`clickview${id}`);
    if (element) element.click();
  }

  // Render helpers
  let sort_by = {
    all_users: { name: "All users" },
    approve: { name: "Approve" },
    not_approve: { name: "Not Approve" },
    block: { name: "Block" }
  }

  //   let displaySort = "All users";
  //   if (state.approve === 0) {
  //     displaySort = sort_by.not_approve.name;
  //   } else if (state.approve === 1) {
  //     displaySort = sort_by.approve.name;
  //   } else if (state.approve === -2) {
  //     displaySort = sort_by.block.name;
  //   }

  return (
    <div className="col-12 ">
      <ToastContainer />
      <div className="card card-body card-hover-shadow p-40">
        <h4 className="card-title"><strong>Total user took exam:<b className="text-success fw-500 w-80px"> {state.total.toLocaleString('en-US')}</b></strong> <i className="fa fa-users"> </i></h4>

        <div className="card-body">
          <div className="flexbox mb-20">
            <div className="">
              {/* <div className="lookup"> */}
              {/* <input className="w-250px" type="text" name="s" placeholder="Search" onChange={onSearch} /> */}
            </div>

            <div className="btn-toolbar">
              <div className="btn-group btn-group-sm">
                <button
                  style={{
                    width: "260px",
                    padding: "10px 12px",
                    textAlign: "left"
                  }}
                  ref={buttonRef}
                  onClick={togglePicker}
                  className="px-4 py-2 border rounded-md bg-white"
                >
                  {startDate && endDate
                    ? `${formatDate(startDate)} → ${formatDate(endDate)}`
                    : "Select Date Range"}
                </button>

                {/* Popup Calendar */}
                {showPicker && (
                  <div
                    ref={popupRef}
                    style={{
                      position: "absolute",
                      zIndex: 999,
                      marginTop: 10,
                      background: "white",
                      border: "1px solid #ddd",
                      borderRadius: 8,
                      padding: 10
                    }}
                  >
                    <DatePicker
                      selected={startDate}
                      onChange={handleDateChange}
                      startDate={startDate}
                      endDate={endDate}
                      selectsRange
                      inline
                      dateFormat="yyyy-MM-dd"
                    />
                  </div>
                )}
                <button className="btn btn-primary" onClick={() => { getAllUsersTestResult() }} >Search</button>
                <div className="btn-group btn-group-sm ml-2 d-none d-sm-flex">
                  <button className="btn btn-info dropdown-toggle" data-toggle="dropdown">Export</button>
                  <div className="dropdown-menu dropdown-menu-right">
                    <Link className="dropdown-item" onClick={() => exportToPdf(state.users, "Student Test Result")} ><i className="fa fa-file-pdf-o"></i> PDF </Link>
                    <Link className="dropdown-item" onClick={(event) => { exportUsersToExcel(state.users, "Student Test Result") }}  ><i className="fa fa-file-excel-o"></i> Excel</Link>
                  </div>
                </div>
                {/* <button className="btn btn-info dropdown-toggle" data-toggle="dropdown">Sort By: {displaySort}</button> */}
                <div className="dropdown-menu dropdown-menu-right">
                  <Link className="dropdown-item" onClick={(e) => {
                    e.preventDefault();
                    setState(prev => ({ ...prev, approve: -1, page: 1 }));
                    // Effect will trigger fetch
                  }}><i className="fa fa-users"></i>All</Link>
                  <Link className="dropdown-item" onClick={(e) => {
                    e.preventDefault();
                    setState(prev => ({ ...prev, approve: 1, page: 1 }));
                  }}><i className="fa fa-check"></i>Approved</Link>
                  <Link className="dropdown-item" onClick={(e) => {
                    e.preventDefault();
                    setState(prev => ({ ...prev, approve: 0, page: 1 }));
                  }}><i className="fa fa-user"></i>Not yet approve</Link>
                  <Link className="dropdown-item" onClick={(e) => {
                    e.preventDefault();
                    setState(prev => ({ ...prev, approve: -2, page: 1 }));
                  }}><i className="fa fa-user-times"></i>Block</Link>
                </div>
              </div>
              <div className="btn-group btn-group-sm ml-2 d-none d-sm-flex">


              </div>
            </div>
          </div>
          <div>
          </div>

          <table className="table table-hover table-has-action">
            <thead>
              <tr>
                <th className="text-center w-20px"><h6>#</h6></th>
                <th className="text-center w-180px"><h6>User Name</h6></th>
                <th className="text-center "><h6>Gender</h6></th>
                <th className="text-center "><h6>Generation</h6></th>
                <th className="text-center w-160px"><h6>Exam Date</h6></th>
                <th className="text-center w-180px"><h6> Reading</h6></th>
                <th className="text-center w-180px"><h6> Listening</h6></th>
                <th className="text-center "><h6>Total</h6></th>
                <th className="text-center w-180px"><h6>Blind Test</h6></th>
                <th className="text-center  w-140px "><h6>Actions</h6></th>
              </tr>
            </thead>
            <tbody>

              {
                state.users?.map((user, index) => {

                  return <tr key={user.id}>
                    <th onClick={() => linkToNewPage(user.id)} className="text-center w-20px" scope="row"> <b>{((state.page - 1) * state.limit) + (index + 1)}</b></th>
                    {/* <td><img style={{width: 30, height: 30, borderRadius: 30}} src={user.profile_url} alt="user profile" /></td> */}

                    <td onClick={() => linkToNewPage(user.id)} className="text-center w-180px"><strong>{user.user?.last_name + ' ' + user.user?.first_name}</strong></td>
                    <td onClick={() => linkToNewPage(user.id)} className="text-center w-150px">{user.user?.gender_id == 1 ? "Male" : "Female"}</td>
                    <td onClick={() => linkToNewPage(user.id)} className="text-center ">{user.user?.generation}</td>
                    <td onClick={() => linkToNewPage(user.id)} className="text-center w-150px">{moment(user.created_at).format("DD-MMM-YYYY")}</td>
                    <td onClick={() => linkToNewPage(user.id)} className="text-center table-actions">{user.result.reading * 2.5} ({user.result.reading}/{user.result.total_reading})</td>
                    <td onClick={() => linkToNewPage(user.id)} className="text-center table-actions">{user.result.listen * 2.5} ({user.result.listen}/{user.result.total_listing})</td>
                    <td onClick={() => linkToNewPage(user.id)} className="text-center table-actions">{(user.result.reading + user.result.listen) * 2.5}</td>
                    <td onClick={() => linkToNewPage(user.id)} className="text-center table-actions">{user.result.blind_test}/{user.result.total_blind_test}</td>
                    <td onClick={() => linkToNewPage(user.id)} className="text-center table-actions text-center ">
                      <span>&nbsp;</span><Link title="Edit" className="btn btn-square btn-round btn-primary" to={`/usertestresultview?id=${user.id}`}><i id={`clickview${user.id}`} className="ti-eye"></i></Link>
                    </td>
                  </tr>
                })
              }
            </tbody>
          </table>
          <Pagination
            onPaginationPress={handlePagination}
            totalPageLength={state.total}
            limit={state.limit}
            selectPage={state.page}
          />
        </div>
      </div>
    </div>
  );
}

export default UserTestResultIndex;
